import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export type LanguageCode = 'fr' | 'en';

export const LANGUAGES: LanguageCode[] = ['fr', 'en'];
export const DEFAULT_LANGUAGE: LanguageCode = 'fr';
export const FALLBACK_LANGUAGE: LanguageCode = 'en';

const STORAGE_KEY = 'lms.lang';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private translate = inject(TranslateService);

  init(): void {
    this.translate.addLangs([...LANGUAGES]);
    const saved = localStorage.getItem(STORAGE_KEY) as LanguageCode | null;
    this.set(saved === 'en' || saved === 'fr' ? saved : DEFAULT_LANGUAGE);
  }

  current(): LanguageCode {
    return this.translate.getCurrentLang() === 'en' ? 'en' : 'fr';
  }

  set(lang: LanguageCode): void {
    this.translate.use(lang);
    localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
  }

  flagUrl(lang: LanguageCode): string {
    return `/assets/flags/${lang}.svg`;
  }
}
